import React from "react";
import PropTypes from "prop-types";
import { FaCheckCircle } from "react-icons/fa";

const StatusIcon = ({ value }) => {
  return (
    <span className={value ? "text-success" : "text-warning"}>
      <FaCheckCircle />
    </span>
  );
};

StatusIcon.propTypes = {
  value: PropTypes.bool
};

StatusIcon.propTypes = {
  value: PropTypes.bool
};

export default StatusIcon;
